import React from "react";
import { Minus, Plus } from "lucide-react";

interface BookCardKidsOrdersProps {
  book: KidsBook;
  userClient?: Client;
  selectedBooks: { bookId: string; quantity: number }[];
  onQuantityChange: (bookId: string, quantity: number, bookNum: number) => void;
}
const bookNames: { [key: number]: string } = {
  1: "Magic Village",
  2: "Jungle World",
  3: "Robo City",
  4: "Space Mission",
  5: "Time Travel",
};

const BookCardKidsOrders: React.FC<BookCardKidsOrdersProps> = ({
  book,
  userClient,
  selectedBooks,
  onQuantityChange,
}) => {
  if (!book.id) return null;

  const basePrice = book.price!;
  let finalPrice = basePrice;
  const clientDiscounts = userClient?.discounts || [];

  clientDiscounts.forEach((discount) => {
    finalPrice -= (basePrice * discount.valuePercent) / 100;
  });

  const quantity =
    selectedBooks.find((item) => item.bookId === book.id)?.quantity || 0;

  const handleChange = (newQty: number) => {
    onQuantityChange(book.id!, newQty, book.num);
  };

  return (
    <>
      <div className="flex h-full flex-col md:bg-white/40 md:shadow-sm md:rounded-[28px] md:p-4">
        <img
          src={require(`../assets/Kids${book.num}.jpg`)}
          alt={`Książka ${book.num}`}
          className=" object-contain rounded-[22px]"
        />
        <div className="mt-4 flex-1 text-center">
          <p className="text-[0.68rem] font-semibold uppercase tracking-[0.26em] text-slate-500">
            Student&apos;s Book
          </p>
          <span className="mt-2 block min-h-[3.5rem] text-sm font-semibold leading-6 text-slate-900">
            English Unlocked {book.num}
            <span className="mt-1 block text-base font-normal italic leading-6 text-slate-900">
              {bookNames[book.num]}
            </span>
          </span>
        </div>

        <div className="mt-2 rounded-[22px] border border-white/85 px-4 py-3 text-center shadow-[0_10px_24px_rgba(148,163,184,0.17)] backdrop-blur-lg">
          {finalPrice !== basePrice ? (
            <>
              <span className="block text-sm font-semibold text-slate-500 line-through">
                {basePrice?.toFixed(2)} PLN
              </span>
              <span className="mt-1 block text-base font-semibold text-rose-500">
                {finalPrice?.toFixed(2)} PLN
              </span>
            </>
          ) : (
            <span className="block text-base font-semibold text-slate-800">
              {basePrice?.toFixed(2)} PLN
            </span>
          )}
        </div>

        <div className="mt-2 flex items-center rounded-full border border-white/80 p-2 shadow-[0_10px_24px_rgba(148,163,184,0.17)] backdrop-blur-lg">
          <button
            type="button"
            onClick={() => handleChange(Math.max(0, quantity - 1))}
            className="flex items-center justify-center text-black/60"
          >
            <Minus size={26} />
          </button>
          <input
            type="number"
            min={0}
            value={quantity}
            onChange={(e) => handleChange(parseInt(e.target.value) || 0)}
            className="w-full bg-transparent text-center text-base font-semibold text-slate-900 outline-none no-spinner"
          />
          <button
            type="button"
            onClick={() => handleChange(quantity + 1)}
            className="flex items-center justify-center  text-black/60"
          >
            <Plus size={26} />
          </button>
        </div>
      </div>
    </>
  );
};

export default BookCardKidsOrders;
